import DdFooterButton from '@/components/DdFooterButton'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import validators from '@/rahmen/validators'
// import dolly from '@/rahmen/utils/dolly'
// import modals from '@/ddv2.library/modals'

// import message from '@/ddv2.library/messages'
import tax from '@/ddv2.library/tax'
import header from '@/ddv2.library/header'
// import modals from '@/ddv2.library/modals'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const DdDropDown = () => import('@/components/DdDropDown')
const DdDataTable = () => import('@/components/DdDataTable')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdSimpleTable = () => import('@/components/DdSimpleTable')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')

export default {
  name: 'TohoKoteiKamotsu',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdTextBox,
    DdDateBox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdTextBoxSwitching,
    DdTimeBoxSwitching,
    DdDropDown,
    DdDataTable,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdSimpleTable,
    DdNumericBox,
    DdFooterButton,
    DdTextBoxPlaceHolderFree
  },
  data: () => ({
    invalidMessages: {},
    id: 0,
    hinmokuCount: 0,
    modeOfEdit: 2,
    modeKengen: 2,
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    rec: {
      vwTeikeiKihon: {},
      mstKingaku: {},
      vwTeikeiHinmokuList: [{}]
    },
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    conditionsKamotsu: {
      teikeiKihonNo: ''
    },
    /*
     * 金額項目表示用定義
     */
    recDispKingakuKomokuList: [{}],
    recDispKingakuInfo: {},
    /*
     * 商品情報編集用定義
     */
    recShohinInfo: {},
    // オートコンプリート定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    // ----------------------------------------------------------------------------------------------------
    // ダイアログ定義
    // ----------------------------------------------------------------------------------------------------
    shohinEditDialog: false,
    shohinEditIndex: -1,
    shohinMaxIndex: -1,
    // 表示制御
    hatsuchiSwitch: false,
    chakuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiHmsSwitch: false,
    hinmeiSwitch: false,
    shohinSeikyuKingakuMinyuryoku: false,
    // ----------------------------------------------------------------------------------------------------
    // データテーブル用定義
    // ----------------------------------------------------------------------------------------------------
    shohinInfoHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: 'No', value: 'teikeiHinmokuNo' },
      { text: '商品種別', value: 'shohinSbtNm' },
      { text: '商品コード', value: 'shohinmeiCd' },
      { text: '商品名', value: 'shohinmeiNm' },
      { text: '数量', value: 'teikeiSuryo', align: 'end' },
      { text: '単位', value: 'tanniNm', align: 'center' },
      { text: '重量(t)', value: 'teikeiJuryo', align: 'end' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '請求金額', value: 'seikyuKingaku', align: 'end' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ]
  }),
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      taxList: 'DDMasters/msysTax'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 卸先マスタフィルター --> ここから
    filteredOroshisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.torihikisakiBunruiKbn1 === '01'
      })
    },
    // 卸先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 品名マスタフィルター <-- ここまで
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    // 往復種別フィルター
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 品目品種フィルター
    filteredHinmokuSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    // 商品情報テーブルフィルター --> ここから
    filteredShohinInfoRows () {
      // データがない場合の制御
      if (!this.rec.vwTeikeiHinmokuList.map) { return }

      return this.rec.vwTeikeiHinmokuList.map((elem) => {
        if (elem.teikeiSuryo !== undefined && elem.teikeiSuryo !== '' && elem.teikeiSuryo !== null) { elem.teikeiSuryo = filter.numericFormatter(elem.teikeiSuryo) }
        if (elem.teikeiJuryo !== undefined && elem.teikeiJuryo !== '' && elem.teikeiJuryo !== null) { elem.teikeiJuryo = filter.numericMinorDigitFormatter(elem.teikeiJuryo, 4) }
        if (elem.tanka !== undefined && elem.tanka !== '' && elem.tanka !== null) { elem.tanka = filter.numericMinorDigitFormatter(elem.tanka, 4) }
        if (!elem.shohinmeiCd && elem.hinmeiBiko) { elem.shohinmeiNm = elem.hinmeiBiko }
        if (elem.seikyuKingaku !== undefined && elem.seikyuKingaku !== '' && elem.seikyuKingaku !== null) { elem.seikyuKingaku = filter.numericFormatter(elem.seikyuKingaku) }
        return elem
      })
    },
    // 商品情報テーブルフィルター <-- ここまで
    // 請求運賃算出
    seikyuKihonUnchinAmount () {
      // 品目レコードが存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.vwTeikeiHinmokuList === undefined) { return 0 }
      if (this.rec.vwTeikeiHinmokuList.length === 0) { return 0 }
      if (this.recShohinInfo.seikyuKingaku === null || this.recShohinInfo.seikyuKingaku === '') { return 0 }

      let amount = 0

      // 集計
      this.rec.vwTeikeiHinmokuList.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(this.removeComma(target.seikyuKingaku))
      }).map(k => {
        // 金額項目を数値に変換
        return parseInt(this.removeComma(k.seikyuKingaku), 10)
      }).forEach(k => {
        amount += k
      })
      return amount
    },
    // 請求税抜き額算出
    seikyuTsukoryoZeinukiAmount () {
      if (this.isUchizeiTsukoryoInfoDisable === false) { return 0 }
      return this.taxExcludedCalculation(this.rec.vwTeikeiKihon.seikyuTsukoryo)
    },
    // 請求合計金額算出
    seikyuGokeiAmount () {
      let amount = 0

      let seikyuTsukoryo = this.rec.vwTeikeiKihon.seikyuTsukoryo
      if (this.isUchizeiTsukoryoInfoDisable === true) { seikyuTsukoryo = '0' }
      let seikyuKingaku1 = this.rec.vwTeikeiKihon.seikyuKingaku1
      if (this.isDispUserKingaku1 === false) { seikyuKingaku1 = '0' }
      let seikyuKingaku2 = this.rec.vwTeikeiKihon.seikyuKingaku2
      if (this.isDispUserKingaku2 === false) { seikyuKingaku2 = '0' }
      let seikyuKingaku3 = this.rec.vwTeikeiKihon.seikyuKingaku3
      if (this.isDispUserKingaku3 === false) { seikyuKingaku3 = '0' }
      if (this.rec.vwTeikeiKihon.seikyuTsukoryo === undefined || this.rec.vwTeikeiKihon.seikyuTsukoryo === '') { seikyuTsukoryo = '0' }
      if (this.rec.vwTeikeiKihon.seikyuKingaku1 === undefined || this.rec.vwTeikeiKihon.seikyuKingaku1 === '') { seikyuKingaku1 = '0' }
      if (this.rec.vwTeikeiKihon.seikyuKingaku2 === undefined || this.rec.vwTeikeiKihon.seikyuKingaku2 === '') { seikyuKingaku2 = '0' }
      if (this.rec.vwTeikeiKihon.seikyuKingaku3 === undefined || this.rec.vwTeikeiKihon.seikyuKingaku3 === '') { seikyuKingaku3 = '0' }

      amount = this.seikyuKihonUnchinAmount + parseInt(seikyuTsukoryo, 10) + this.seikyuTsukoryoZeinukiAmount + parseInt(seikyuKingaku1, 10) + parseInt(seikyuKingaku2, 10) + parseInt(seikyuKingaku3, 10)

      return amount
    },
    // 表示用編集
    dispUserKingaku1Label () {
      if (this.recDispKingakuKomokuList.length < 1) { return '' }
      return this.recDispKingakuKomokuList[0].label
    },
    dispUserKingaku2Label () {
      if (this.recDispKingakuKomokuList.length < 2) { return '' }
      return this.recDispKingakuKomokuList[1].label
    },
    dispUserKingaku3Label () {
      if (this.recDispKingakuKomokuList.length < 3) { return '' }
      return this.recDispKingakuKomokuList[2].label
    },
    isDispUserKingaku1 () {
      return this.recDispKingakuKomokuList.length >= 1
    },
    isDispUserKingaku2 () {
      return this.recDispKingakuKomokuList.length >= 2
    },
    isDispUserKingaku3 () {
      return this.recDispKingakuKomokuList.length >= 3
    },
    isShiharaiInfoDisable () {
      var newUriageList = this.rec.vwUriageList.filter((t) => {
        return t.haishaKbn === '03'
      })
      if (newUriageList.length === 0) {
        return false
      } else {
        return true
      }
    },
    isUchizeiTsukoryoInfoDisable () {
      return this.rec.mstKingaku.hiwayPriceShiyoFlg === true
    },
    isUriageInfoShiharaiDisable () {
      return this.recUriageInfo.haishaKbn === '03'
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isUpdateMode () {
      return this.modeOfEdit === 1 || this.modeOfEdit === 2
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        hinmokuCount: this.hinmokuCount,
        hatsuchiSwitch: this.hatsuchiSwitch,
        chakuchiSwitch: this.chakuchiSwitch,
        hatsuchiHmsSwitch: this.hatsuchiHmsSwitch,
        chakuchiHmsSwitch: this.chakuchiHmsSwitch
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const option = {
        nextCallback: next
      }
      this.preventTransition(option)
    },
    fetchData: function () {
      console.log('fetchData')
      return new Promise((resolve) => {
        console.log(this.rec.vwTeikeiKihon.id)
        this.HttpClient
          .get(`/api/v1/D2mstd03600/KoteiKamotsuInfoSearch?id=${this.id}`)
          .then((data) => {
            if (data.isValid === false) { return this.setInvalidSummaryMessage(data.summaryMessage.messageCd) }

            if (data.payload) {
              this.hatsuchiSwitch = false
              this.chakuchiSwitch = false
              this.hatsuchiHmsSwitch = false
              this.chakuchiHmsSwitch = false
              // ==================================================
              // 固定貨物基本情報
              // ==================================================-
              if (data.payload.vwTeikeiKihon) {
                this.rec.vwTeikeiKihon = data.payload.vwTeikeiKihon

                if (this.rec.vwTeikeiKihon.hatsuchiHms) { this.rec.vwTeikeiKihon.hatsuchiHms = (this.rec.vwTeikeiKihon.hatsuchiHms).slice(0, 5) }

                if (this.rec.vwTeikeiKihon.oroshichiHms) { this.rec.vwTeikeiKihon.oroshichiHms = (this.rec.vwTeikeiKihon.oroshichiHms).slice(0, 5) }

                if (this.rec.vwTeikeiKihon.hinmokuCount) { this.hinmokuCount = this.rec.vwTeikeiKihon.hinmokuCount }

                if (!this.rec.vwTeikeiKihon.hatsuchiId && this.rec.vwTeikeiKihon.hatsuchiBiko) { this.hatsuchiSwitch = true }

                if (!this.rec.vwTeikeiKihon.hatsuchiHms && this.rec.vwTeikeiKihon.hatsuchiHmsBiko) { this.hatsuchiHmsSwitch = true }

                if (!this.rec.vwTeikeiKihon.oroshichiId && this.rec.vwTeikeiKihon.oroshichiBiko) { this.chakuchiSwitch = true }

                if (!this.rec.vwTeikeiKihon.oroshichiHms && this.rec.vwTeikeiKihon.oroshichiHmsBiko) { this.chakuchiHmsSwitch = true }
              }
              // ==================================================
              // 金額マスタ情報
              // ==================================================-
              if (data.payload.mstKingaku) {
                this.rec.mstKingaku = data.payload.mstKingaku

                // if (this.rec.mstKingaku.hiwayPriceShiyoFlg === true) { this.rec.vwTeikeiKihon.seikyuTsukoryo = tax.calcTaxToIncluded(this.rec.vwTeikeiKihon.seikyuTsukoryo, '01', new Date()) }
              }
              // ==================================================
              // 商品情報
              // ==================================================-
              if (data.payload.vwTeikeiHinmokuList) {
                this.rec.vwTeikeiHinmokuList = data.payload.vwTeikeiHinmokuList
              }
              /* // 複写ボタン押下時
              if (this.copyMode === 1) {
                this.rec.vwTeikeiKihon.id = 0
                this.rec.vwTeikeiKihon.teikeiKihonNo = null
                this.DeleteButtonDisp = false
                this.NewButtonDisp = true
                this.CopyButtonDisp = true
                this.isReadonlyMode1 = false
                this.isShoukaiMode = false
                this.$refs.teikeiKihonNo.innerValue = null
              // 通常時
              } else if (this.copyMode === 0) {
                if (this.rec.vwTeikeiKihon.id === 0) {
                  // 新規モード
                  this.modeOfEdit = 0
                } else if (this.rec.vwTeikeiKihon.seikyuZumiFlg === false) {
                  // 更新1：更新モードかつ請求済みフラグ==false
                  this.modeOfEdit = 1
                } else {
                  // 更新2：更新モードかつ請求済みフラグ==true
                  this.modeOfEdit = 2
                }

                if (this.modeOfEdit !== 0) {
                  this.isReadonlyMode1 = true
                } else {
                  this.isReadonlyMode1 = false
                }
                if (this.modeOfEdit === 2) {
                  this.isShoukaiMode = true
                } else {
                  this.isShoukaiMode = false
                }
                if (this.modeKengen === 2 && this.modeOfEdit === 1) {
                  this.DeleteButtonDisp = true
                } else {
                  this.DeleteButtonDisp = false
                }

                if (this.modeOfEdit === 0) {
                  this.CopyButtonDisp = true
                } else {
                  this.CopyButtonDisp = false
                }

                if (this.modeOfEdit !== 0) {
                  this.NewButtonDisp = true
                } else {
                  this.NewButtonDisp = false
                }
              } */
              // this.copyMode = 0
              this.clearInvalidMessage(this.$refs)
              // this.cloneData = dolly.clone(this.getCloneTargetMethod())
            }
            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'msthacchakuchi', 'msthinmei', 'mstshubetsu', 'msyskubun', 'msystax'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            self.rec.vwTeikeiKihon.ohfukuSbtCd = c.ohfukuSbtCd
            self.rec.vwTeikeiKihon.seikyuShashuSbtCd = c.seikyuShashuSbtCd
            resolve()
          })
        },
        existsIdMethod: () => {
          console.log('existsIdMethod')
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // ----------------------------------------------------------------------------------------------------
    // 貨物No反映ボタン押下
    // ----------------------------------------------------------------------------------------------------
    // kamotsuNoSync: function (p) {
    //   console.log(' **** XXXXX **** kamotsuNoSync', p)
    //   this.rec.vwTeikeiKihon.teikeiKihonNo = p
    //    this.fetchData()
    // },
    // ----------------------------------------------------------------------------------------------------
    // 金額項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 荷主IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeNinushi: function () {
      if (!this.rec.vwTeikeiKihon.ninushiId) {
        this.recDispKingakuKomokuList = []
        this.recDispKingakuInfo = {}
        return
      }
      console.log('changeNinushiId')
      this.getKingakuKomoku(this.rec.vwTeikeiKihon.ninushiId)
    },
    getKingakuKomoku: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/D2mstd03600/KingakuInfoFind?id=${this.rec.vwTeikeiKihon.ninushiId}`)
          .then((data) => {
            this.rec.mstKingaku = data.payload
            console.log('getKingakuKomoku', this.rec.mstKingaku)
            this.kingakuSetting()
          })
        resolve()
      })
    },
    kingakuSetting: function () {
      this.recDispKingakuKomokuList = []
      if (this.rec.mstKingaku === null) { return }
      // 通行料課税・内税どちらか一方のみ設定されていない場合、エラー
      if (this.rec.mstKingaku.hiwayPriceShiyoFlg === true && this.rec.mstKingaku.userKingakuKazei10ShiyoFlg === true) { return this.setInvalidSummaryMessage('COME0023') }
      if (this.rec.mstKingaku.hiwayPriceShiyoFlg === false && this.rec.mstKingaku.userKingakuKazei10ShiyoFlg === false) { return this.setInvalidSummaryMessage('COME0023') }

      if (this.rec.mstKingaku.userKingakuKazei1ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuKazei1Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuKazei2ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuKazei2Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuKazei3ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuKazei3Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuHikazei1ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuHikazei1Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuHikazei2ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuHikazei2Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuHikazei3ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuHikazei3Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      // ユーザ選択金額項目が4項目以上設定されていた場合、エラー
      if (this.recDispKingakuKomokuList.length > 3) {
        this.recDispKingakuKomokuList = []
        this.recDispKingakuInfo = {}
        return this.setInvalidSummaryMessage('COME0024')
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 商品情報編集
    // ----------------------------------------------------------------------------------------------------
    onShohinEditNewButtonClick: function (item) {
      if (this.isShoukaiMode === true) { return }
      this.shohinEditIndex = -1
      this.recShohinInfo = {}
      this.recShohinInfo.id = -1
      this.recShohinInfo.shohinSbtCd = null
      this.recShohinInfo.tanniCd = null
      this.shohinSeikyuKingakuMinyuryoku = true
      this.hinmeiSwitch = false
      this.shohinEditDialog = true
    },
    onShohinEditOpenButtonClick: function (item) {
      this.shohinEditIndex = this.rec.vwTeikeiHinmokuList.indexOf(item)
      this.recShohinInfo = Object.assign({}, item)
      if (!this.recShohinInfo.mstHinmeiId && this.recShohinInfo.hinmeiBiko) { this.hinmeiSwitch = true }
      this.shohinSeikyuKingakuMinyuryoku = false
      this.shohinEditDialog = true
    },
    onShohinEditMoveUpButtonClick: function (item) {
      const index = this.rec.vwTeikeiHinmokuList.indexOf(item)
      if (index === 0 || index === -1) { return }
      this.rec.vwTeikeiHinmokuList.splice(
        index - 1,
        2,
        this.rec.vwTeikeiHinmokuList[index],
        this.rec.vwTeikeiHinmokuList[index - 1])
      const tempTeikeiHinmokuNo = this.rec.vwTeikeiHinmokuList[index - 1].teikeiHinmokuNo
      this.rec.vwTeikeiHinmokuList[index - 1].teikeiHinmokuNo = this.rec.vwTeikeiHinmokuList[index].teikeiHinmokuNo
      this.rec.vwTeikeiHinmokuList[index].teikeiHinmokuNo = tempTeikeiHinmokuNo
    },
    onShohinEditMoveDownButtonClick: function (item) {
      const index = this.rec.vwTeikeiHinmokuList.indexOf(item)
      if (index === this.rec.vwTeikeiHinmokuList.length - 1 || index === -1) { return }
      this.rec.vwTeikeiHinmokuList.splice(
        index,
        2,
        this.rec.vwTeikeiHinmokuList[index + 1],
        this.rec.vwTeikeiHinmokuList[index])
      const tempTeikeiHinmokuNo = this.rec.vwTeikeiHinmokuList[index].teikeiHinmokuNo
      this.rec.vwTeikeiHinmokuList[index].teikeiHinmokuNo = this.rec.vwTeikeiHinmokuList[index + 1].teikeiHinmokuNo
      this.rec.vwTeikeiHinmokuList[index + 1].teikeiHinmokuNo = tempTeikeiHinmokuNo
    },
    onShohinEditDeleteButtonClick: function (item) {
      if (this.isShoukaiMode === true) { return }
      const index = this.rec.vwTeikeiHinmokuList.indexOf(item)
      this.recShohinInfo = Object.assign({}, item)
      this.recShohinInfo.editFlg = true
      this.recShohinInfo.delFlg = !this.recShohinInfo.delFlg
      this.recShohinInfo.seikyuKingaku = '0'
      Object.assign(this.rec.vwTeikeiHinmokuList[index], this.recShohinInfo)
    },
    onShohinEditCloseButtonClick: function () {
      this.shohinEditDialog = false
      this.hinmeiSwitch = false
      this.$nextTick(() => {
        this.recShohinInfo = Object.assign({}, null)
        this.recShohinInfo.mstHinmeiId = null
        this.shohinEditIndex = -1
        this.shohinSeikyuKingakuMinyuryoku = true
      })
    },
    onShohinEditSaveButtonClick: function () {
      // 商品種別
      this.recShohinInfo.shohinSbtNm = this.getShubetsuNm('GVIJ02', this.recShohinInfo.shohinSbtCd)
      // 単位
      this.recShohinInfo.tanniNm = this.getShubetsuNm('SVI001', this.recShohinInfo.tanniCd)
      // 品名名称
      this.recShohinInfo.shohinmeiCd = this.getHinmeiCd(this.recShohinInfo.mstHinmeiId)
      this.recShohinInfo.shohinmeiNm = this.getHinmeiNm(this.recShohinInfo.mstHinmeiId)
      // 数値項目が入力されていないとき、0を代入
      if (!this.recShohinInfo.teikeiSuryo) { this.recShohinInfo.teikeiSuryo = '0' }
      if (!this.recShohinInfo.teikeiJuryo) { this.recShohinInfo.teikeiJuryo = '0' }
      if (!this.recShohinInfo.tanka) { this.recShohinInfo.tanka = '0' }
      if (!this.recShohinInfo.seikyuKingaku) { this.recShohinInfo.seikyuKingaku = '0' }

      if (this.shohinEditIndex > -1) {
        this.recShohinInfo.editFlg = true
        Object.assign(this.rec.vwTeikeiHinmokuList[this.shohinEditIndex], this.recShohinInfo)
        this.onShohinEditCloseButtonClick()
      } else {
        this.recShohinInfo.id = -1
        this.recShohinInfo.editFlg = true
        this.recShohinInfo.delFlg = false
        // 定型コース品目番号 ※FechDataでこの定型コースに紐づく品目データのMAX値を取得しといて、そこに+1する。this.rec.vwTeikeiHinmokuList.HinmokuCount
        this.hinmokuCount++
        this.recShohinInfo.teikeiHinmokuNo = this.hinmokuCount

        if (this.rec.vwTeikeiHinmokuList.length > 0) {
          this.rec.vwTeikeiHinmokuList.push(this.recShohinInfo)
        } else {
          this.rec.vwTeikeiHinmokuList = [this.recShohinInfo]
        }
      }
      this.recShohinInfo = {}
      this.recShohinInfo.id = -1
      this.recShohinInfo.shohinSbtCd = null
      this.recShohinInfo.tanniCd = null
      this.recShohinInfo.mstHinmeiId = null
      this.$refs.mstHinmeiId.innerValue = null
      this.hinmeiSwitch = false
    },
    onSaveShohinInfo: function (row, target, input) {
      if (input === undefined) { return false }
      const inputPrice = this.removeComma(input)
      if (!window.isFinite(inputPrice)) { return }
      row[target] = filter.numericFormatter(inputPrice)
      this.onShohinEditCloseButtonClick()
    },
    // ----------------------------------------------------------------------------------------------------
    // 数量*単価で商品情報請求金額の初期値を設定 ※商品情報請求金額未入力時
    // ----------------------------------------------------------------------------------------------------
    calcShohinSeikyuKingaku: function () {
      if (this.shohinSeikyuKingakuMinyuryoku) {
        if (this.recShohinInfo.teikeiSuryo && this.recShohinInfo.tanka) {
          var calcSeikyuUnchin = this.recShohinInfo.teikeiSuryo * this.recShohinInfo.tanka
          calcSeikyuUnchin = calcSeikyuUnchin === 0 ? 0 : Math.round(calcSeikyuUnchin)
          this.$set(this.recShohinInfo, 'seikyuKingaku', calcSeikyuUnchin)
        }
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 商品情報請求金額を変更時の自動計算挙動制御
    // ----------------------------------------------------------------------------------------------------
    inputShohinSeikyuKingaku: function () {
      if (this.recShohinInfo.seikyuKingaku === null || this.recShohinInfo.seikyuKingaku === '') {
        this.shohinSeikyuKingakuMinyuryoku = true
      } else {
        this.shohinSeikyuKingakuMinyuryoku = false
      }
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.hinmokuCount = self.cloneData.hinmokuCount
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.HttpClient.post('/api/v1/D2mstd03600/KoteiKamotsuInfoDelete', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {
            ohfukuSbtCd: self.rec.vwTeikeiKihon.ohfukuSbtCd,
            seikyuShashuSbtCd: self.rec.vwTeikeiKihon.seikyuShashuSbtCd
          }
        }
        /* settingReloadWindow: function () {
          return true
        } */
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.vwTeikeiKihon.id = 0
          self.modeOfEdit = 0
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.vwTeikeiKihon.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {
            ohfukuSbtCd: self.rec.vwTeikeiKihon.ohfukuSbtCd,
            seikyuShashuSbtCd: self.rec.vwTeikeiKihon.seikyuShashuSbtCd
          }
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.rec.vwTeikeiKihon.id === 0) {
        console.log(this.rec, 'KamotsuCreate')
        f = this.HttpClient.post('/api/v1/D2mstd03600/KoteiKamotsuCreate', this.rec)
      } else {
        console.log(this.rec, 'Update')
        f = this.HttpClient.post('/api/v1/D2mstd03600/KoteiKamotsuUpdate', this.rec)
      }
      return f
    },
    registerValidate: function () {
      var msg
      if (this.rec.vwTeikeiKihon.hatsuchiYmd && this.rec.vwTeikeiKihon.oroshichiYmd) {
        msg = validators.compareDate(this.rec.vwTeikeiKihon.hatsuchiYmd, this.rec.vwTeikeiKihon.oroshichiYmd)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.oroshichiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.hinmokuCount = 0
      this.rec.vwTeikeiKihon = {}
      this.rec.mstKingaku = {}
      this.rec.vwTeikeiHinmokuList = []
      this.recDispKingakuKomokuList = []
      this.recDispKingakuInfo = {}
      this.recShohinInfo = {}
      this.copyMode = 0
      this.hatsuchiSwitch = false
      this.chakuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiHmsSwitch = false
      this.hinmeiSwitch = false
      this.shohinSeikyuKingakuMinyuryoku = false
      this.rec.vwTeikeiKihon.id = 0
      this.rec.vwTeikeiHinmokuList.HinmokuCount = 0

      // dd-code-text-boxにbindしている項目は明示的にNullを設定する事
      this.rec.vwTeikeiKihon.teikeiKihonNo = null
      this.rec.vwTeikeiKihon.tantoEigyoshoId = null
      this.rec.vwTeikeiKihon.ninushiId = null
      this.rec.vwTeikeiKihon.hatsuchiId = null
      this.rec.vwTeikeiKihon.oroshisakiId = null
      this.rec.vwTeikeiKihon.oroshichiId = null
      this.recShohinInfo.mstHinmeiId = null
    },
    // データ取得
    getEigyoshoCd: function (pEigyoshoId) {
      var eigyosho = this.eigyoshoList.filter((t) => {
        return t.id === pEigyoshoId
      })
      if (eigyosho.length > 0) {
        return eigyosho[0].eigyoshoCd
      }
      return ''
    },
    getEigyoshoNm: function (pEigyoshoId) {
      var eigyosho = this.eigyoshoList.filter((t) => {
        return t.id === pEigyoshoId
      })
      if (eigyosho.length > 0) {
        return eigyosho[0].eigyoshoNm
      }
      return ''
    },
    getHinmeiCd: function (pHinmeiId) {
      var hinmei = this.hinmeiList.filter((t) => {
        return t.id === pHinmeiId
      })
      if (hinmei.length > 0) {
        return hinmei[0].hinmeiCd
      }
      return ''
    },
    getHinmeiNm: function (pHinmeiId) {
      var hinmei = this.hinmeiList.filter((t) => {
        return t.id === pHinmeiId
      })
      if (hinmei.length > 0) {
        return hinmei[0].hinmeiNm
      }
      return ''
    },
    getShubetsuNm: function (pSbtShuruiCd, pSbtCd) {
      var shubetsu = this.shubetsuList.filter((t) => {
        return t.sbtShuruiCd === pSbtShuruiCd && t.sbtCd === pSbtCd
      })
      if (shubetsu.length > 0) {
        return shubetsu[0].sbtNm
      }
      return ''
    },
    getKubunNm: function (pKbnShuruiCd, pKbnCd) {
      var kubun = this.kubunList.filter((t) => {
        return t.kbnShuruiCd === pKbnShuruiCd && t.code === pKbnCd
      })
      if (kubun.length > 0) {
        return kubun[0].codeNm
      }
      return ''
    },
    rowColorClass: function (item) {
      return item.delFlg === true ? 'row_delete' : ''
    },
    removeComma: function (num) {
      if (!num) { return }

      if (window.isFinite(num) === true) {
        return num
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },
    // 税抜き計算
    taxExcludedCalculation (data) {
      // 通行料が入力されていない場合
      if (data === undefined || data === '') { return 0 }
      if (data === 0) { return 0 }

      const zeinukiKingaku = tax.calcWithoutTax5u6d(data, new Date())

      return zeinukiKingaku
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    }
  }
}
